import { EmployeeDeleteStatus } from "@src/types";
import {
  columnTypes,
  paginationGridOptions,
  preventPinnedColumnJumpingGridOption,
} from "@src/utils/aggrid_utils";
import {
  ColDef,
  GetRowIdParams,
  GridOptions,
  RowClassParams,
} from "ag-grid-community";

export const columns: ColDef[] = [
  {
    field: "fullName",
    headerName: "Full name",
  },
  {
    field: "teamLead",
    headerName: "Team lead",
    cellRenderer: "showTeamLeadRenderer",
    width: 180,
  },
  {
    field: "projectLead",
    headerName: "Project lead",
    cellRenderer: "showProjectLeadRenderer",
    width: 180,
  },
  {
    width: 10,
    pinned: "right",
    colId: "checkbox",
    checkboxSelection: true,
    suppressFillHandle: true,
  },
  {
    pinned: "right",
    width: 40,
    minWidth: 20,
    suppressFillHandle: true,
    cellRenderer: "errorIconRenderer",
    filterParams: {
      newRowsAction: "keep",
    },
  },
];

export const gridOptions: GridOptions = {
  ...paginationGridOptions,
  ...preventPinnedColumnJumpingGridOption,
  paginationPageSize: 5,
  suppressContextMenu: true,
  rowSelection: "multiple",
  rowHeight: 60,
  domLayout: "autoHeight",
  suppressRowClickSelection: true,
  columnDefs: columns,
  defaultColDef: {
    ...columnTypes.default,
    sortable: false,
    resizable: false,
  },
  context: {
    projectLeads: [],
    teamleads: [],
  },
  rowClassRules: {
    "error-row": function (params: RowClassParams) {
      return !!params.node.data.errorMessage;
    },
  },
  getRowId: function (params: GetRowIdParams<EmployeeDeleteStatus>) {
    return params.data.employeeId.toString();
  },
};
